export const skillSets = [
  "All",
  "Programming Languages",
  "Full Stack",
  "Database Management",
  "ML frameworks",
  "Design",
  "Tools",
];
